module.exports = __webpack_public_path__ + "img/icon_5_47.75bf4349.png";